<p *ngIf="params.data && params.data?.BatchsId>0" class="custom-tooltip">
    This orderid already in batch
</p>